import React, { useEffect } from "react";

interface IProps {
    componentProps: { [key: string]: any }
    componentId: string,
    componentReference: (element: Element, props: any) => any
}

const DOMRenderer: React.FC<IProps> = ({ componentReference, componentProps, componentId }) => {
    useEffect(() => {
        const renderElement = document.getElementById(componentId)
        if (renderElement)
            componentReference?.(renderElement, componentProps);
    }, []);

    const renderElement = document.getElementById(componentId)
    if (renderElement) {
        componentReference?.(renderElement, componentProps);
    }
    return (
        <div id={componentId}></div>
    )
}

export default DOMRenderer;